import { useContext, useEffect, useState } from "react"
import services from "../../../../services/services";
import { Urls } from "../../../../services/Urls";
import _ from "underscore";
import { callautopopulate } from "../../../../services/callautopop";
import { useCreateNode } from "./useCreateNode";
import { ToastContext } from "../../../../context/ToastContext";

export const useSurveyNode = () => {

    const { showSuccess, showError } = useContext(ToastContext);
    const [showCreate, setShowCreate] = useState({ visible: false, data: null, delete: { visible: false, data: null } });
    const [nodes, setNodes] = useState([]);
    const [options, setOptions] = useState([]);
    const [loader, setLoader] = useState({ card: false, dropdown: {}, delete: null })
    const { upsertNode } = useCreateNode({ editNode: {}, onClose: () => { }, nodeOptions: [] });
    const [filterValues, setFilterValues] = useState({});

    useEffect(() => {
        callautopopulate("survey_relation")?.then(res => {
            setOptions((prev) => ({
                ...prev,
                relations: res?.survey_relation?.sort((a, b) => a?.relation_name?.localeCompare(b?.relation_name)),
            }));
        })
    }, [])

    useEffect(() => {
        filterValues?.apiCall && getNodes();
    }, [filterValues?.apiCall])

    const getNodes = async (fromRelationUpdate) => {
        try {
            !fromRelationUpdate && setLoader((prev) => ({ ...prev, card: true }));
            const payload = {
                users: _.pluck(filterValues?.users, "user_code")?.toString() || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("GETSURVEYNODEDETAILS"), payload);
            if (res?.body?.error_status === false) {
                const data = res?.body?.data;
                let nodesArr = [];
                Object.values(_.groupBy(data?.node_summary, "node_id"))?.forEach((value) => {
                    const obj = {
                        node_id: value?.[0]?.node_id,
                        node_name: value?.[0]?.node_name,
                        node_description: value?.[0]?.node_description,
                        members: value?.filter(item => item?.node_member_name)?.sort((a, b) => a?.node_member_name?.localeCompare(b?.node_member_name)) || [],
                        eligible_pairs: _.filter(data?.node_details, { node_id: value?.[0]?.node_id }) || [],
                        relationsCount: _.groupBy(value, "relation_name")
                    }
                    nodesArr.push(obj);
                })
                setNodes(nodesArr);
            }
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setLoader((prev) => ({ ...prev, card: false, dropdown: {} }));
            setFilterValues((prev) => ({...prev, apiCall: false}))
        }
    }

    const handleRelationChange = async (node, user, e) => {
        try {
            const selectedRelation = _.findWhere(options?.relations, { relation_id: e?.target?.value })
            let relations = {};
            node?.members?.forEach(item => {
                relations[item?.node_member_user_code] = item?.node_member_user_code === user?.node_member_user_code ? selectedRelation : item
            })
            const updatedNode = {
                node_id: node?.node_id,
                node_name: node?.node_name,
                node_description: node?.node_description,
                activePairs: node?.eligible_pairs,
                selectedUsers: _.pluck(node?.members, "node_member_user_code"),
                relations
            }
            setLoader((prev) => ({ ...prev, dropdown: { [`${node?.node_id}-${user?.node_member_user_code}`]: true } }));
            await upsertNode(updatedNode);
            getNodes(true);
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    const deleteNode = async () => {
        try {
            setLoader((prev) => ({ ...prev, delete: true }));
            const res = await services.getInvokeRemote("POST", Urls("REMOVESURVEYNODEDETAILS"), { node_id: showCreate?.delete?.data?.node_id || 0 });
            if (res?.body?.error_status === false) {
                showSuccess("Success", res?.body?.message);
                setShowCreate((prev) => ({ ...prev, delete: { visible: false, data: null } }));
                getNodes();
            } else {
                res?.body?.message && showError("Error", res?.body?.message);
            }
        } catch (error) {
            console.error("Error: ", error);
            error?.response?.data?.errorMessage && showError("Error", error?.response?.data?.errorMessage);
        } finally {
            setLoader((prev) => ({ ...prev, delete: false }));
        }
    }

    return { showCreate, setShowCreate, getNodes, nodes, options, handleRelationChange, loader, deleteNode, filterValues, setFilterValues }
}